// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-flight[data-v-8bc56f8e]{color:#787878;font-size:13px;font-weight:600;text-transform:uppercase}.airports i[data-v-8bc56f8e]{margin-left:5px;margin-right:5px}.passengers-class[data-v-8bc56f8e]{font-weight:400;text-transform:none}.passengers-class i[data-v-8bc56f8e]{font-size:18px;left:0;margin-right:5px;position:absolute;top:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
